import { Injectable } from "@angular/core";
import { AppNavItem } from "@lantern/app/models";
import { Observable, ReplaySubject } from "rxjs";
import { map } from "rxjs/operators";

@Injectable()
export class MockAppNavService {
  _filteredMenu: AppNavItem[] = [];
  loggedIn = new ReplaySubject<boolean>(1);
  filteredMenu$: Observable<AppNavItem[]> = this.loggedIn.pipe(
    map((loggedIn) => {
      if (loggedIn) {
        return this._filteredMenu;
      } else {
        return [];
      }
    })
  );
}
